import {
  RATES_SIGNAL, RatesSignalTypes, RATES_CLASSES, RATES_LABELS, RATES_ORDER, RATES_REQUIRED
} from '@autos/auto-results/components/auto-detail-rates/constants/rates';
import {
  RatesTypes, RateUI
} from '@autos/auto-results/components/auto-detail-rates/entities/rates';
import { Price } from '@app/entities/price';
import {
  getPaymentDiscountAmount, getPaymentPercentageCalculated
} from '@shared/payment-detail/mappers/discount-calculated.mapper';

export function mapReservationToPrice(price: Price): Price {
  let amountTaxes = 0;
  if (Array.isArray(price.Taxes)) {
    price.Taxes.forEach(tax => {
      amountTaxes += tax.Amount;
    });
  } else {
    amountTaxes = price.Taxes;
  }
  return {
    Taxes: amountTaxes,
    Total: price.Total,
    Amount: price.Amount,
    Fees: price.Fees,
    Surcharges: price.Surcharges,
    DiscountAmount: price.DiscountAmount,
    CommissionAmount: price.CommissionAmount,
    CurrencyCode: price.CurrencyCode,
    PenaltyAmount: price.PenaltyAmount
  };
}
export function mapPriceToRates(price: Price, priceAtDestination: number, totalPayNow: number = null): RateUI[] {
  const rates: RateUI[] = [];

  let idx = Object.keys(RATES_LABELS).length;
  for (let key of Object.keys(RATES_LABELS)) {
    let value = 0;
    value = (price[key]) ? price[key] : 0;
    key = (key === RatesTypes.Total && totalPayNow) ? RatesTypes.TotalPay : key;

    if (value !== 0 || (RATES_REQUIRED[key])) {
      if (!(totalPayNow && key === RatesTypes.Taxes)) {
        rates.push({
          className: getRateClass(key),
          id: key,
          value: key === RatesTypes.DiscountAmount ? getPaymentDiscountAmount(
            price?.Strikethrough, price?.Total, price?.DiscountAmount, (
              price?.TotalDiscountInStrikethrough || price?.TotalDiscount
            )
          ) : value,
          ...(key === RatesTypes.DiscountAmount) && {
            percentage: getPaymentPercentageCalculated(
              true, price?.Strikethrough, price?.Total, price?.DiscountAmount, (
                price?.TotalDiscountInStrikethrough || price?.TotalDiscount
              ), price?.Amount, price?.Taxes as number
            )
          },
          label: (RATES_LABELS[key]) ? RATES_LABELS[key] : '',
          order: (RATES_ORDER[key]) ? RATES_ORDER[key] : idx++,
          signal: (RATES_SIGNAL[key]) ? RATES_SIGNAL[key] : RatesSignalTypes.NONE
        });
      }
    }
  }

  if (totalPayNow && priceAtDestination) {
    rates.push({
      className: getRateClass(RatesTypes.TotalPayNow),
      id: RatesTypes.TotalPayNow,
      value: totalPayNow,
      label: (RATES_LABELS[RatesTypes.TotalPayNow]) ? RATES_LABELS[RatesTypes.TotalPayNow] : '',
      order: (RATES_ORDER[RatesTypes.TotalPayNow]) ? RATES_ORDER[RatesTypes.TotalPayNow] : idx++,
      signal: (RATES_SIGNAL[RatesTypes.TotalPayNow]) ? RATES_SIGNAL[RatesTypes.TotalPayNow] : RatesSignalTypes.NONE
    });

    rates.push({
      className: getRateClass(RatesTypes.PaymentAgency),
      id: RatesTypes.PaymentAgency,
      value: priceAtDestination,
      label: RATES_LABELS[RatesTypes.PaymentAgency],
      order: RATES_ORDER[RatesTypes.PaymentAgency],
      signal: RATES_SIGNAL[RatesTypes.PaymentAgency]
    });
  }

  return rates.sort((a, b) => a.order - b.order);
}

function getRateClass(label: string): string {
  return (RATES_CLASSES[label]) ? RATES_CLASSES[label] : '';
}
